export function absoluteOffset(element: HTMLElement) {
  let top = 0
  let left = 0

  let currentElement = element

  do {
    top += currentElement.offsetTop || 0
    left += currentElement.offsetLeft || 0

    currentElement = currentElement.offsetParent as HTMLElement
  } while (currentElement)

  return { top, left }
}
